import React from "react";
import { Row, Col, Button } from "reactstrap";
import getConfig from "next/config";

const config = getConfig().publicRuntimeConfig;

const MissionsCardRight = (props) => {

  const { slug, image, buttonText, stats, name } = props.mission;

  const number = stats.percentage_reached;

  const completed_percentage = Math.floor(number, -2);

  return (
    <Row
      style={{
        borderBottom: "1px solid #dddddd",
        marginBottom: "0.5rem",
        paddingBottom: "0.5rem",
      }}
    >
      <Col lg="5" md="6" sm="6" xs="6" style={{}} className="p-0">
        <a
          href={`/missions/${slug}`}
          onClick={() => {
            if (window.eventDispatcher) {
              window.eventDispatcher.dispatchEventSync(
                "missions-card-btn-desktop-image",
                {},
                { amplitude: true }
              );
            }
          }}
        >
          <img
            src={`${config.cdnUrl}${image.imgUrlPath}${image.imgUrl}`}
            alt={image.imgAlt}
            style={{ height: "7rem" }}
          />
        </a>
      </Col>
      <Col lg="7" md="6" sm="6" xs="6" className="p-0">
        <p>{name} </p>
        <p style={{ paddingTop: "4px", color: "#008c8c" }}>
          {completed_percentage}% funded
        </p>

        <a
          href={`/missions/${slug}`}
          onClick={() => {
            if (window.eventDispatcher) {
              window.eventDispatcher.dispatchEventSync(
                "missions-card-btn-desktop-left",
                {},
                { amplitude: true }
              );
            }
          }}
        >
          <Button
            color="primary"
            className="btn-full-width btn  btn-primary"
            style={{ marginTop: "12px" }}
          >
            <img
              className="give-now-button-icon"
              src={`${config.cdnUrl}/static/icons/heart-donation-programs-page.svg`}
              alt="Hearts"
            />
            {buttonText}
          </Button>
        </a>
      </Col>
    </Row>
  );
};

export default MissionsCardRight;
